import { computed, unref } from 'vue';

import { classesStates, propsFactory } from '@components/utils';

import type { ComputedRef, PropType } from 'vue';

export interface IDisabledProps {
  disabled: boolean;
}
export interface IUseDisabled {
  disabledClasses: ComputedRef<string | undefined>;
}

export const makeDisabledProps = propsFactory(
  {
    /**
     * Заблокированное состояние
     */
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'disabled'
);

export function useDisabled(props: IDisabledProps): IUseDisabled {
  const disabledClasses = computed(() => {
    const { disabled } = unref(props);
    return disabled ? classesStates.disabled : undefined;
  });

  return { disabledClasses };
}
